import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import arrowrighticon from "../../assets/photos/arrow-left.png";

//second part of register component the register password component
const RegisterPassword = (props) => {
  const [password, setPassword] = useState("");
  const [confirmpassword, setCPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  //toastify container pops up if the error message passed in props is not null
  if (props.error) {
    toast.error(props.error, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  //method to handle change
  const handleInputChange = (event) => {
    if (event.target.id === "form-ctrl-password") {
      setPassword(event.target.value);
    }
    if (event.target.id === "form-ctrl-conformpassword") {
      setCPassword(event.target.value);
    }
  };

  // method called when we press register button and calls props.setpasswordmethod(password) and passes the password
  const handleOnSubmit = (event) => {
    let a = "";
    if (
      event.target.id === "buttonedit" &&
      password.length >= 4
      // password !== confirmpassword
    ) {
      if (password !== confirmpassword) {
        a = "  * Passwords are not same";
        // document.getElementById("passsword-validation-error").innerHTML = a;
      } else {
        a = "";
        props.setpasswordmethod(password);
        // let a = "  * Passwords are not same";
      }
    } else if (event.target.id === "buttonedit" && password.length < 4) {
      a = "  * Password is too small minimum length required is 4 characters";
    }
    setErrorMessage(a);
  };


  //method called if ( <- ) button in clicked, it goes back to register component
  const goBack = () => {
    props.gobackmethod();
  };

  return (
    <div className="background-image">
      <div className="line-color-background">
        <span className="register-login">REGISTER</span>
      </div>
      <Container fluid>
        <Row>
          <Col xs={1} />
          <Col xs={10}>
            <div className="login-text-details">TO GUIDE APP</div>
            <Button id="button-arrow-right" onClick={goBack}>
              <img src={arrowrighticon} />
            </Button>
            <Form>
              <Form.Group>
                <Form.Label>Create a password</Form.Label>
                <Form.Control
                  id="form-ctrl-password"
                  type="password"
                  onChange={handleInputChange}
                  placeholder="Create a password"
                  autoComplete="off"
                />
                <Form.Control
                  autoComplete="off"
                  id="form-ctrl-conformpassword"
                  type="password"
                  onChange={handleInputChange}
                  placeholder="Confirm your password"
                />
              </Form.Group>
              <p className="show-alert" id="passsword-validation-error">
                {errorMessage}
              </p>
              <div>
                <NavLink id="login-register-link" to="/login">
                  Have an account already ?
                </NavLink>
                <Button
                  id="buttonedit"
                  onClick={(event) => handleOnSubmit(event)}
                >
                  Register
                </Button>
              </div>
            </Form>
          </Col>
          <Col xs={1} />
        </Row>
      </Container>
      {props.error ? (

        // toaster container
        
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      ) : null}
    </div>
  );
};

export default RegisterPassword;
